<template>
  <div :class='["stat", editable ? "editable" : "", config.showValue ? "with-value" : "without-value"]'>
    <div class='actions' v-if='editable && !content.question'>
      <h2 class='editHeading' @click.prevent='onEdit'>Add a statistic <ion-icon name="add-circle-outline"></ion-icon></h2>
    </div>

      <div class="figure" v-if='content.showValue && content.question'>
        <div class='figure-content' v-if='!circle'>
          <ContentEditable ref='figureContent' tag='h2' :key='figureKey' :style='{color: computedFigureColor}' :font-scale='computedFigureSize' v-if='editable && content.question' :editable='editable' v-model='figure'></ContentEditable>
          <div class='figure' :style='{color: computedFigureColor, fontSize: computedFigureSize + "%"}' v-if='!editable && content.question'>
            <h2>{{figure}}</h2>
          </div>
        </div>
        <VueCircle v-if='circle' :config='circleConfig' :progress='result.percent' :title='figure'></VueCircle>
      </div>
      <div class="caption" v-if='content.question'>
        <ContentEditable ref='captionContent' tag='p' :key='captionKey' :html='true' :style='{color: computedCaptionColor}' :font-scale='computedCaptionSize' :editable='editable' placeholder='Subtitle' default='<i>Subtitle</i>' v-model='content.text' :translated='translated'></ContentEditable>
        <div v-if='editable'>
          <UIActions :buttons='["delete", "edit"]' @edit='onEdit' @delete='onDelete'></UIActions>
        </div>
      </div>

  </div>
</template>
<script>
import Vue from 'vue'
import UIActions from './UIActions.vue'
import ContentEditable from '../../ContentEditable.vue'
import VueCircle from '../../Circle.vue'
export default {
  name: 'Stat',
  props: {
    config: {type: Object, default: () => {{}}},
    data:  {type: Object, default: () => {{}}},
    theme: {type: Object, default: () => {{}}},
    circle: {type: Boolean, default: true},
    editable: {type: Boolean, default: false},
    id: null,
    translated: {type: String, default: null}
  },
  data () {
    return {
      circleConfig: {backgroundStroke: '#ffffff', stroke: this.theme.color, titleColor: this.theme.color},
      figureKey: this.randomKey(),
      captionKey: this.randomKey(),
      content: {},
      ready: false
    }
  },
  components: {
    UIActions,
    ContentEditable,
    VueCircle
  },
  inject: ['globalTheme'],
  computed: {
    valueScale () {
      return this.content.options.valueScale
    },
    figure: {
      get () {
        if (this.content.valueText && this.content.valueText !== '') {
          return this.content.valueText
        }
        let output = ''
        let pc = 0

        if (!Array.isArray(this.content.answer)){
          this.config.answer = [this.content.answer]
        }
        for (let answer of this.content.answer) {
          let result = this.data[this.content.question][answer]
          pc += Math.round(result.percent * 100, 2)
        }
        return pc + '%'
      },
      set (val) {
        this.content.valueText = val
      }
    },
    computedFigureColor () {
      // have to patch in a color on the globalTheme if this is an old campaign, because they won't include campaign styles.
      let globalColor = null
      if (typeof this.globalTheme.campaign !== 'undefined') {
        globalColor = this.globalTheme.campaign.secondary.color
      }
      return this.content.figureColor || this.theme.statColor || globalColor || this.globalTheme.brandTitleColor
    },
    computedCaptionColor () {
      // have to patch in a color on the globalTheme if this is an old campaign, because they won't include campaign styles.
      let globalColor = null
      if (typeof this.globalTheme.campaign !== 'undefined') {
        globalColor = this.globalTheme.campaign.secondary.color
      }
      return this.content.captionColor || this.theme.statTextColor || globalColor || this.globalTheme.brandTextColor
    },
    computedFigureSize () {
      return this.content.figureFontSize || this.theme.titleFontSize
    },
    computedCaptionSize () {
      return this.content.captionFontSize || this.theme.textFontSize
    },
    result () {
      return this.data[this.content.question][this.content.answer]
    }
  },
  methods: {
    randomKey () {
      return Math.floor(Math.random() * 999999).toString()
    },
    onDelete () {
      this.$emit('delete', this.id)
    },
    onEdit () {
      this.$emit('edit', {target: this, fields: null, editorClass: 'StatEditPanel'})
    },
    reload() {
      this.figureKey = this.randomKey()
      this.captionKey = this.randomKey()
    }
  },
  created () {
    this.content = this.config
  },
  watch: {
    config: {
      handler: function (newConfig) {
        this.content = newConfig
        Vue.nextTick(() => {
          this.$refs.figureContent.reload()
          this.$refs.captionContent.reload()
        })

      }
    },
    content: {
      handler: function(newConfig) {
        if (!this.ready) {
          this.ready = true
          return
        }
        this.$emit('change', this.content)
      },
      deep: true
    },
    theme: function(newTheme){
      this.circleConfig.titleColor = this.theme.color;
      this.circleConfig.stroke = this.theme.color
    }
  }
}
</script>
<style lang='scss' scoped>
  .stat {

    .actions {
      width: 100%;
      display: flex;
      min-height: 100px;
      align-items: center;
      justify-content: center;
    }
    .editHeading {
      text-align: center;
      color: #ccc;
      width: 50%;
      cursor: pointer;
      font-size: 200%;
      ion-icon {
        vertical-align: -5px;
      }
    }

    position: relative;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    @media (min-width: 768px) {
      flex-direction: row;
      min-height: 150px;
    }
    & + .stat {
      //margin-top: 2rem;
    }
    .figure {
      flex: 0 0 35%;
      display: flex;
      align-items: center;
      justify-content: center;
      .figure-content {
        /deep/ h2 {
          margin: 0;
          word-break: break-all;
          font-size: 6em;
          @media (min-width: 768px) {
            font-size: 3em;
          }
          @media (min-width: 920px) {
            font-size: 4em;
          }
          @media (min-width: 1200px) {
            font-size: 6em;
          }
        }

      }
    }
    .caption {
      flex: 0 1 65%;
      font-size: 100%;
      display: flex;
      align-items: center;
      /deep/ .content-editable {
          margin:auto;
        @media (min-width: 768px){
          margin:0;
        }
      }
      /deep/ p {
        margin: 0.5rem;
        @media (min-width: 920px){
          padding-left: 1rem;
          font-size: 170%;
        }
      }
    }
    &.editable {

    }
    .figure {
      text-align: center;
    }
    /deep/ .content-editable p {
      font-weight: normal;
      position: relative;
      z-index: 1;
      span.question, span.answer {
        font-weight: bold;
      }
    }
    /deep/ .ui-actions {
      z-index: 3;
    }
  }
  .stat.without-value {
    .caption {
      flex: 1 1 100%;
      font-size: 100%;
      display: flex;
      align-items: center;
      /deep/ p {
        margin: 0.5rem;
        @media (min-width: 920px){
          padding-left: 0rem;
          font-size: 170%;
        }
      }
    }
  }
</style>